import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';

export const authenticationGuard: CanActivateFn = (route, state) => {
    let authenticationService = inject(AuthenticationService);
    let router = inject(Router);
    return authenticationService.ping().pipe(
        map(pingResult => {
            if (pingResult) {
                return pingResult;
            } else {
                return getLoginPageUrlTree(router);
            }
        }),
        catchError(() => of(getLoginPageUrlTree(router)))
    );
};

const getLoginPageUrlTree: (router: Router) => UrlTree = (router: Router) => router.createUrlTree(['authentication']);
